import React, { useContext, useEffect, useState } from "react";
import { createTheme } from "@mui/material";
import { Button } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import serverHost from "../../../services/serverHost";
import musicaCategoria from "../../../enums/musicaCategoria";

export default function Musicas({ unidadeId }) {
  const [carregando, setCarregando] = useState(false);
  const [listaMusicas, setListaMusicas] = useState([]);
  const [novaMusica, setNovaMusica] = useState(false);
  const [musicaSelecionada, setMusicaSelecionada] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listarMusicas();
  }, []);

  const listarMusicas = () => {
    setCarregando(true);

    api
      .get("unidades/listarMusicas", { unidadeId })
      .then((musicas) => {
        setListaMusicas(musicas);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Erro ao listar os Músicas");
        setCarregando(false);
      });
  };

  const abrirMusica = (registro) => {
    setMusicaSelecionada(registro);
  };

  const salvarMusica = (musica) => {
    const data = new FormData();

    data.append("unidadeId", unidadeId);
    data.append("nome", musica.nome);
    data.append("categoria", musica.categoria);
    data.append("disponivelPais", musica.disponivelPais);
    data.append("disponivelProf", musica.disponivelProf);

    if (musica.arquivo && musica.arquivo[0])
      data.append("arquivo", musica.arquivo[0]);

    if (musicaSelecionada.id > 0) {
      musica.id = musicaSelecionada.id;
      data.append("id", musicaSelecionada.id);

      api
        .post("unidades/editarMusica", data)
        .then((res) => {
          notification("success", "Música editada!");
          setNovaMusica(false);
          setMusicaSelecionada({});
          listarMusicas();
        })
        .catch((err) => notification("error", "Erro ao editar a música"));
    } else {
      api
        .put("unidades/inserirMusica", data)
        .then((res) => {
          notification("success", "Música salva!");
          setNovaMusica(false);
          setMusicaSelecionada({});
          listarMusicas();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Unidade inválida");

            default:
              return notification("error", "Música inválida");
          }
        });
    }
  };

  const removerMusica = () => {
    api
      .delete("unidades/removerMusica", { musicaId: musicaSelecionada.id })
      .then((res) => {
        notification("success", "Música removida!");
        setNovaMusica(false);
        setMusicaSelecionada({});
        listarMusicas();
      })
      .catch((err) => notification("error", "Erro ao remover a música"));
  };

  const tRegistros = {
    title: "Músicas Da Unidade",
    onLineClick: abrirMusica,
    columns: [
      {
        name: "nome",
        label: "Música",
      },
      {
        name: "categoria",
        label: "Categoria",
        domain: musicaCategoria,
      },
      {
        name: "disponivelProf",
        label: "Disponível p/ profissionais",
        checkbox: true,
      },
      {
        name: "disponivelPais",
        label: "Disponível p/ pais",
        checkbox: true,
      },
    ],
    array: listaMusicas,
  };

  const filtros = {
    form: {
      arquivo: {
        label: "Alterar arquivo",
        type: "file",
      },
      nome: {
        label: "Nome",
        type: "text",
        value: musicaSelecionada.nome,
        space: 6,
      },
      categoria: {
        label: "Categoria",
        type: "select",
        value: musicaSelecionada.categoria,
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 1,
            desc: "Americana",
          },
          {
            value: 2,
            desc: "Britânica",
          },
          {
            value: 3,
            desc: "Instrumental",
          },
          {
            value: 4,
            desc: "História",
          },
          {
            value: 5,
            desc: "Exercício",
          },
        ],
      },
      player: {
        type: "component",
        value: (
          <audio
            preload="none"
            src={`${serverHost()}/${musicaSelecionada.caminhoArquivo}`}
            controls
          />
        ),
      },
      disponivelProf: {
        label: "Disponível p/ profissionais",
        type: "check",
        value: novaMusica ? true : musicaSelecionada.disponivelProf,
        space: 6,
      },
      disponivelPais: {
        label: "Disponível p/ pais",
        type: "check",
        value: novaMusica ? true : musicaSelecionada.disponivelPais,
        space: 6,
      },
    },

    submit: {
      label: "Salvar",
      action: salvarMusica,
    },
    close: {
      label: "Fechar",
      action: () => {
        setNovaMusica(false);
        setMusicaSelecionada({});
      },
    },

    customActions:
      musicaSelecionada.id > 0
        ? [
            {
              label: "Remover",
              action: () => removerMusica(),
            },
          ]
        : undefined,
  };

  return (
    <div>
      {novaMusica || musicaSelecionada.id > 0 ? (
        <Form formData={filtros} />
      ) : (
        <>
          <ThemeProvider theme={theme}>
            <Button
              style={{ margin: "0px 10px 0px 10px" }}
              variant="contained"
              sx={{ color: "#FFFF" }}
              onClick={() => setNovaMusica(true)}
            >
              +
            </Button>
          </ThemeProvider>
          <br />
          <br />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
const theme = createTheme({
  palette: {
    primary: {
      main: "#fa9702",
      color: "white",
    },
  },
});
